import axiosInstance from "@/utils/axios.instance";
import { toast } from "react-toastify";

export const axiosMiddleware = (store: any) => (next: any) => (action: any) => {
  setInterceptors(store);

  return next(action);
};

export const setInterceptors = (store: any) => {
  axiosInstance.interceptors.request.use(
    async (config: any) => {
      const state = await store.getState();
      const accessToken = state?.auth?.user?.accessToken;
      config.headers.Authorization = `Bearer ${accessToken}`;
      return config;
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    function (response: any) {
      return response;
    },
    function (error: any) {
      if (
        error?.response?.status == 401 &&
        error?.response?.data?.message == "Unauthorized"
      ) {
        toast.error(
          "Session has expired. You will be redirected to login page.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        window.location.href = "/";
      }

      return Promise.reject(error);
    }
  );
};
